import { css } from '@emotion/react';
import { styles } from '@frontend/design-system';

export const nameStyle = [
  styles.truncate,
  css`
    flex: 1;
  `,
];
